import React from 'react';

import css from './PlaidLoader.module.scss';
import layoutCSS from '../../Layout/Layout.module.scss';

const PlaidLoader = () => (
  <div className={layoutCSS.layoutWrapper}>
    <h1 data-e2e={`plaid-loader-header`}>Securing your information...</h1>
    <div
      className={css.loadingContainer}
      data-e2e="plaid-loading-screen"
      data-testid="plaid-loader"
    >
      <img
        className={css.loadingImage}
        src={`/static/plaid-loading-screen.gif`}
        alt={`Secure Loading`}
      />
    </div>
  </div>
);

export default PlaidLoader;
